import { Fragment } from "react";
import { Breadcrumb, Container } from "react-bootstrap";
import { useEffect, useState } from "react";
import clsx from "classnames";
import unslug from "unslug";
import classes from "./styles.module.scss";

export const Breadcrumbs = ({ className, title, disabled }) => {
  const [paths, setPaths] = useState([]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const pathname = window.location.pathname;

      setPaths(
        pathname
          .split("/")
          .map((i, k) => {
            if (k === 0) {
              return { label: "Home", url: "/" };
            }

            if (disabled.includes(i)) {
              return { label: unslug(i).replace(/\d+/g, ""), url: false };
            }

            if (i) {
              return { label: unslug(i).replace(/\d+/g, ""), url: `${pathname.split(i)[0]}${i}/` };
            }
          })
          .filter((i) => !!i)
      );
    }
  }, []);

  return (
    <Container fluid="lg" className={clsx(className, classes.breadcrumbs, "py-3 px-0")}>
      <Breadcrumb listProps={{ className: "mb-0" }}>
        {paths.map(({ label, url }, k) => (
          <Fragment key={k}>
            {url ? (
              <Breadcrumb.Item href={url}>{k >= paths.length - 1 && title ? title : label}</Breadcrumb.Item>
            ) : (
              <li className="breadcrumb-item">
                <span>{k >= paths.length - 1 && title ? title : label}</span>
              </li>
            )}
            {k < paths.length - 1 && (
              <li className="breadcrumb-divider">
                <span>/</span>
              </li>
            )}
          </Fragment>
        ))}
      </Breadcrumb>
    </Container>
  );
};

Breadcrumbs.defaultProps = {
  title: null,
  disabled: [],
};
